import { render, staticRenderFns } from "./TheReport.vue?vue&type=template&id=b85f27da&scoped=true&"
import script from "./TheReport.vue?vue&type=script&lang=js&"
export * from "./TheReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85f27da",
  null
  
)

export default component.exports